import {
    Alert,
    Card,
    CardContent,
    CardHeader,
    Grid,
    List,
    ListItem,
    ListItemText,
    Typography
} from '@mui/material';
import { Suspense, useEffect, useState } from 'react';
import SynonymCard from 'src/views/search/SynonymCard';
import UserDictCard from 'src/views/search/UserDictCard';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import CustomChip from '../../components/mui/chip';
import PageHeader from '../../components/page-header';
import { useGetStatusQuery } from '../../store/indexApi';
import TableSnapshots from '../../views/search/TableSnapshots';

const SearchEngine = () => {
    const [reload, setReload] = useState(0);
    const [health, setHealth] = useState(null);
    const [info, setInfo] = useState(null);
    const { data, error } = useGetStatusQuery();
    
    useEffect(() => {
        data && setHealth(data.data);
    }, [data]);

    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const response = await apiService.get('/admin/search/index');
                const payload = response.data;
                setInfo(payload.data);
            } catch (e) {
                console.error('Error fetching search index info:', e);
            }
        }

        fetchInfo();
    }, [])

    const showHealth = (status) => {
        switch(status) {
            case "green":
                return <CustomChip skin='light' size='small' label="OK" color="success" />
            case "yellow":
                return <CustomChip skin='light' size='small' label="Warning" color="warning" />
            case "red":
                return <CustomChip skin='light' size='small' label="NOT OK" color="error" />
            default:
                return <CustomChip skin='light' size='small' label="Unknown" />
        }
    }

    return (
        <Page title="Search Engine">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <>
                            <Typography variant='h5' color='#666CFF'>
                                검색엔진 관리
                            </Typography>
                            <Typography variant='body2'>
                                상품 검색엔진 관리자 페이지 입니다.
                            </Typography>
                        </>
                    }
                    subtitle={
                        <Card sx={{mt:4}}>
                            <CardHeader
                                subheader={
                                    <Alert severity='info'>매일 2시에 인덱싱 작업이 실행됩니다.</Alert>
                                }
                            />
                            <CardContent>
                                <List>
                                    <ListItem>
                                        <ListItemText
                                            primary={<>현재 {info?.provided_name} 인덱스 상태는 <span>{showHealth(health)}</span></>}
                                            secondary={`Last 업데이트: ${info?.creation_date}`}
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card> 
                    }
                />
                <Grid item xs={12}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <TableSnapshots reload={reload} setReload={setReload} />
                    </Suspense>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <SynonymCard />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <UserDictCard />
                </Grid>                
            </Grid>
        </Page>
    )
}

export default SearchEngine;